module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"geographical-audience-by-state":"Geographical audience by state"},"pt":{"geographical-audience-by-state":"Audiência geográfica por estado"},"es":{"geographical-audience-by-state":"Audiencia geográfica por estado"}}')
  delete Component.options._Ctor
}
